module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-BlackItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-BlackItalic.eot
// module id = 1887
// module chunks = 0